import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c109c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex row items-center" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = {
  key: 0,
  class: "reward_amount"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "col-12 q-py-lg q-px-md",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "ID:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1))
const _hoisted_10 = { class: "col-6 flex items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "Offer:", -1))
const _hoisted_12 = { class: "col-6 flex items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "Income:", -1))
const _hoisted_14 = {
  key: 0,
  class: "reward_amount"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-6 q-mb-md" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Registration date:", -1))
const _hoisted_20 = { class: "col-6 q-mb-md" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Conversion date:", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "col-6 q-mb-md" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Status:", -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "col-6 q-mb-md" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Country:", -1))
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = ["alt", "src"]
const _hoisted_32 = { class: "col-6 q-mb-md" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Conversion type:", -1))
const _hoisted_34 = { class: "text-weight-bold" }
const _hoisted_35 = { class: "col-6 q-mb-md" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "Labels:", -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_table, {
      rows: _ctx.rows,
      columns: _ctx.columns,
      "row-key": "id",
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
      loading: _ctx.loading,
      onRequest: _ctx.onRequest,
      "binary-state-sort": "",
      "column-sort-order": "da",
      "rows-per-page-label": _ctx.$t('rows_per_page'),
      grid: _ctx.$q.screen.width <= 1199,
      flat: "",
      style: {"padding-top":"32px"}
    }, _createSlots({
      "body-cell-offerName": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "offer-link underlined text-primary text-weight-bold",
              to: { name: 'offer', params: { id: props.row.offerId } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.offerName), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-geo": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                class: "q-mr-sm",
                height: "10",
                width: "15",
                alt: props.row.geo,
                src: 
                `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.geo}.svg`
              
              }, null, 8, _hoisted_2),
              _createTextVNode(" " + _toDisplayString(props.row.geo), 1)
            ])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-amount": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (props.row.amount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formatAmount(props.row.amount, props.row.currency)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, "—"))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 2
    }, [
      (_ctx.$q.screen.width <= 1199)
        ? {
            name: "item",
            fn: _withCtx((props) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(props.row.id), 1)
                  ]),
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_router_link, {
                      class: "offer-link underlined text-primary text-weight-bold",
                      to: { name: 'offer', params: { id: props.row.offerId } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.offerName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    (props.row.amount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.formatAmount(props.row.amount, props.row.currency)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, "—"))
                  ])
                ]),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.format(props.row.datetime)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    (props.row.conversionDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.format(props.row.conversionDate)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, "—"))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    (props.row.attributes?.advertiserStatus)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.statuses[props.row.status].name) + " ( " + _toDisplayString(props.row.attributes?.advertiserStatus) + " ) ", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.statuses[props.row.status].name), 1))
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("img", {
                        class: "q-mr-sm",
                        height: "10",
                        width: "15",
                        alt: props.row.geo,
                        src: 
                    `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.geo}.svg`
                  
                      }, null, 8, _hoisted_31),
                      _createTextVNode(" " + _toDisplayString(props.row.geo), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, _toDisplayString(props.row.markupType), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    (props.row.trafficProperty)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(props.row.trafficProperty), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_38, "—"))
                  ])
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "rows-per-page-label", "grid"])
  ]))
}